import React from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import Banner from "../../../body/banners/banner";
import GBBanner from "../../../body/banners/gbBanner";
import ErrorModal from "../../../body/forms/components/ErrorModal";
import { useEffect, useMemo } from "react";
import marketing from "../../../../services/marketing";
import PixelsService from '../../../../services/pixels';
import AudioEyeSupport from "../../../../services/audioEyeSupport";
import UserDataFormVertical from "../../global-elements/UserFormDataVertical";
import InvalidStateModal from "../../global-elements/invalidStateModal";
import { FormProvider, useForm } from "react-hook-form";
import Recaptcha from "../../../body/forms/components/recaptcha/Recaptcha";
import Features from "../../global-elements/feature";
import Security from "../../global-elements/security";
import Reputation from "../../global-elements/reputation";
import Trustbox from "../../global-elements/trustbox";
import '../../../../assets/prequal/prequal.css';
import ValidatorService from "../../../../services/validator";
import SubmitApplicationService from "../../../../services/submitApplication";
import AxiosWrapper from "../../../../services/axios";
import AdobeScript from "../../../../services/adobeScript";
import EntersektService from "../../../../services/entersekt";
import FeaturesService from "../../../../services/features";
import { InactiveDetection } from "../../../../services/inactiveDetection";
import SocialProofPopup from "../../global-elements/satisfactionPopup";
import ExitOverlayModal from "../../global-elements/exitOverlayModal";
import { PRODUCT } from "../../../../models/websiteTypesConstants";
import OfferExpirationNotice from "../../add-ons/OfferExpirationNotice";

function Landing() {
    const ada = new AudioEyeSupport();
    const Setting = useStoreState((state) => state.siteSettingsModel);
    const utms = new marketing();
    const info = useStoreState(state => state.applicantModel.applicant);
    const setInfo = useStoreActions(actions => actions.applicantModel.setApplicant);
    const pendingInfo = ["FROZEN", "FROZENPREQUAL", "PENDFEE", "PENDFUNDING", "PENDINFO", "PENDINTERNAL", "CVILOW"];
    const history = useHistory();
    const Submit = SubmitApplicationService()
    const [errorShow, setErrorShow] = useState(false);
    const [recaptchaDisabled, setRecaptchaDisabled] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const methods = useForm({mode: 'onSubmit'});
    const Pixels = new PixelsService();
    const setInitPixels = useStoreActions(actions => actions.setInitPixels);
    const [errorMessage, setErrorMessage] = useState(false);
    const closeError = () => setErrorShow(false)
    const initPixels = useStoreState(state => state.initPixels);
    const getRoutingSettings = useStoreActions(state => state.routingSettingsModel.getRoutingSettings);
    const setFeature = useStoreActions(action => action.siteSettingsModel.overwriteWebsiteSettings);
    const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
    const InvalidState = useStoreState((state) => state.invalidState);
    const setInvalidState = useStoreActions((actions) => actions.setInvalidState);
    const validatorService = new ValidatorService();
    const setApplicationResult = useStoreActions(actions => actions.applicationResultModel.setApplicationResult);
    const setGrandBanckDeclined = useStoreActions(actions => actions.siteSettingsModel.setGrandBanckDeclined);
    const setdisplayTerms = useStoreActions((actions) => actions.setDisplayPrequalTerms);
    const setdisplayResult = useStoreActions((actions) => actions.setDisplayResult);
    const idList = useStoreState(state => state.siteSettingsModel.idList);
    const setIdList = useStoreActions(actions => actions.siteSettingsModel.setIdList);
    const domain = useStoreState(state => state.siteSettingsModel.domain);
    const setAlResult = useStoreActions(actions => actions.setAlResult);
    const adobeAds = new AdobeScript()
    const [isHalfScrolled, setIsHalfScrolled] = useState(false);
    const features = new FeaturesService();
    const setDeclineOffers = useStoreActions(actions => actions.siteSettingsModel.setDeclineOffers);
    const Session = useStoreState((state) => state.siteSettingsModel.Session);
    const lexisNexisUrl = process.env.REACT_APP_LEXIS_NEXIS_URL;
    const lexisNexisEnabledUrls = JSON.parse(process.env.REACT_APP_LEXIS_NEXIS_ENABLED_URLS);
    const entersektUrl = JSON.parse(process.env.REACT_APP_ENTERSEKT_URL);
    const entersektInit = useStoreState((state) => state.siteSettingsModel.entersektInit);
    const setEntersektInit = useStoreActions(actions => actions.siteSettingsModel.setEntersektInit);
    const channelId = JSON.parse(process.env.REACT_APP_ENTERSEKT_CHANNEL_ID);
    const pageId = JSON.parse(process.env.REACT_APP_LEXIS_NEXIS_PAGE_ID);
    const entersektService = useMemo(() => new EntersektService(), []);

    const ENTERSEKT_MAX_RETRIES = 10;
    const ENTERSEKT_RETRY_DELAY_MS = 1000;

    useEffect(() => {
        const maxRetries = ENTERSEKT_MAX_RETRIES;
        const retryDelay = ENTERSEKT_RETRY_DELAY_MS;
        let retryCount = 0;
        let timeoutId;
    
        const attemptInit = () => {
            if (!window.CustomerAuthn || !window.CustomerAuthn.configBuilder) {
                retryCount += 1;
                if (retryCount <= maxRetries) {
                    timeoutId = setTimeout(attemptInit, retryDelay);
                } else {
                    console.error("[Entersekt] SDK not available after max retries. Giving up for this session.");
                }
                return;
            }
    
            entersektService.init(Session);
        };
    
        if (!Session) {
            return;
        }
    
        if (!entersektUrl.includes(window.location.origin)) {
            return;
        }
    
        if (entersektInit) {
            return;
        }
    
        setEntersektInit(true);
        attemptInit();
    
    }, [Session, entersektInit, entersektUrl, channelId, setEntersektInit, entersektService]);

    useEffect(() => {
        const index = lexisNexisEnabledUrls.indexOf(window.location.origin);
        if (!Session || index === -1) {
            return;
        }
    
        const scriptUrl = lexisNexisUrl
            .replace("{Session}", Session)
            .replace("{pageId}", pageId[index]);
    
        const alreadyLoaded = !!document.querySelector(`script[src="${scriptUrl}"]`);
        if (alreadyLoaded) {
            return;
        }
    
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = scriptUrl;
        script.async = true;
    
        document.head.appendChild(script);

    }, [Session, lexisNexisEnabledUrls, lexisNexisUrl, pageId]);

    InactiveDetection.setInactiveTitle("Don’t miss this great offer!");

    useEffect(() => {
        if(!initPixels){
            sessionStorage.setItem('mfaId', '');
            utms.mapper();
            ada.setup();
            ada.LoadNeuroId().setNid(Setting.brandSettings.ProductName);
            adobeAds.setup()
           
            utms.trackEvent(1, "Prequal", "", Setting.productSettings.ProductId, "Flow");
            if (Setting.productSettings.TrafficSource.toLowerCase().match(new RegExp(/icomm/g))) {
                utms.postBackQueue({ idList, applicantId: "", productId: Setting.productSettings.ProductId, siteEvent: 'Landed', productCode: Setting.mainSettings.ProductCode
                }).then((payload) => {
                    (idList === "") ? setIdList(payload) : setIdList(idList + "," + payload);
                })
            }
            setTimeout(() =>  adobeAds.startEvent('page_view'), 5000);
            utms.pushnami(Setting.brandSettings.ProductName);
            Pixels.initialize().pageView("/landing").event("google", "tracking", "landing");
            getRoutingSettings({ Url: domain, Route: window.location.pathname});
            setInfo({ index : 'ProductCode', value : Setting.mainSettings.ProductCode })
            setInfo({ index : 'Url', value : domain })
            setInitPixels(true)
            setAlResult(false)
            window.afjref = () => {
                handleMfaChange(false);
            }
        }
       
    }, []);

    function handleMfaChange(value){
        let temp = Setting.websiteSettings;

        if(value === false){
            temp =  Object.values(temp)
            temp = temp.filter(feature => feature.Name !== 'MFAActive');
            let result = {}

            temp.forEach((item, index) => {
                result[index] = item;
              });
            setFeature(result)
        }
    };

    useEffect(() => {
        window.fn = info.FirstName ?? '';
        window.ln = info.LastName ?? '';

    }, [info]);

    useEffect(() => {
        const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const fullHeight = document.body.scrollHeight;
        const scrolledToBottom = scrollPosition + windowHeight;

        if (scrolledToBottom >= fullHeight / 2) {
        if(isHalfScrolled === false){
            
            setIsHalfScrolled(true)
        }
        
        }
    };
    
    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
    }, [isHalfScrolled]);

    useEffect(() => {
    if (isHalfScrolled) {
        scrollEvent();
    }
    }, [isHalfScrolled]);

    const scrollEvent = () => {
    adobeAds.event('scroll')
    };

    const validateSubmition = async (data) => {
   
        setLoading(true)

            if (!validatorService.preValidations(data, methods, info) ) {
                if(await validatorService.EmailValidate(info.Email, methods)){
                      
                    if(await validatorService.addressValidateV2(info, methods, setInvalidState) === true) {
                        await submit();
                    }
                   
                }
            
                
            }
        
        setLoading(false)
    }

    const submit = async () => {
            await entersektService.submit();
            let result = await Submit.submitApplication(info, true);
            let payload = result.Payload;
         
            if(result.Success){
                if(payload){
                    //GrandBank Stuff
                    setGrandBanckDeclined(payload.IsGrandbank || false);
                    setApplicationResult(payload);
                    //--------------//

                    //Invalid State -> Improved please
                    if(payload.result.toLowerCase() === "statenotvalidforbusiness"){ setInvalidState(true); return false; }
                    //--------------//

                    window.nid('applicationSubmit');
                    window.cl = payload.credit_limit ?? 0;
                    utms.trackEvent(2, "Prequal", payload.ref_number, Setting.productSettings.ProductId, "Flow");
                    if (Setting.productSettings.TrafficSource.toLowerCase().match(new RegExp(/icomm/g))) {
                        utms.postBackQueue({ idList, applicantId: payload.ref_number, productId: Setting.productSettings.ProductId, siteEvent: 'Submitted', productCode: Setting.mainSettings.ProductCode
                        }).then((payload) => {
                            (idList === "") ? setIdList(payload) : setIdList(idList + "," + payload);
                        })
                    }
                    //--------------//

                    //Decline Offers for BMG box
                    setDeclineOffers(payload.DeclineOffers || null);
                    //--------------//

                    window.scrollTo(0, 0);
                    //Approved Call (need an strategy or something here)
                    if(payload.result.toUpperCase() === 'APPROVED'){
                        setdisplayTerms(true);
                    
                        history.push(Setting.MainPath + "terms" +window.location.search)
                        return;
                    }
                    //--------------//
                    setdisplayResult(true)

                    //New Bank Account call for Dynamic call
                    if(features.isLinkBankAccountFeatureEnabled()  && payload.result.toUpperCase() === 'PENDUSER') {
                        history.push(Setting.MainPath + "link-account" + window.location.search);
                        return;
                    }
                    //--------------//
                    //pendinfo call (we need to joi nthis with the approved call, maybe some matrix?)
                    if(pendingInfo.includes(payload.result.toUpperCase())){ history.push(Setting.MainPath + "pendinfo" +window.location.search); return; }
                    //--------------//

                    //Default exit
                    history.push(Setting.MainPath + "decision" +window.location.search)
                    return true;
                    //--------------//
                }
                setErrorShow(true);
                setErrorMessage('An unknown error has occured. Please try again.')
                return false;
            }
            else {
                payload.decline_message='We are currently processing your application, and you will receive a decision within 30 days.'
                setApplicationResult(payload);
                setdisplayResult(true);
                window.scrollTo(0, 0);
                history.push(Setting.MainPath + "decision" + window.location.search);
                return;
            }
    } 

    const boldIf = (element, bold) => (bold ? (<b>{element}</b>) : element)

    return (
    <>
       
       {brandSettings.ProductName === PRODUCT.Grand.bank
            ? <GBBanner />
            : <Banner />
       }
        <ErrorModal size="sm" show={errorShow} message={errorMessage} closeError={closeError}/>
        <ExitOverlayModal disabled={isLoading} />
        <InvalidStateModal visible={InvalidState} />
        
        <div className="" style={{backgroundColor: "#eee"}}>
            <div className="container pt-5 pb-5" >
                <SocialProofPopup></SocialProofPopup>
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(validateSubmition)} className="user-form shaded">
                        <div className="container">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <div className="input-fields">
                                        <UserDataFormVertical disabledFields={isLoading} />
                                        <div className="captcha-container">
                                            {Setting.productSettings.CaptchaKey !== null && (
                                                <div className="form-group displayFlexCenter">
                                                    <Recaptcha setRecaptchaDisabled={setRecaptchaDisabled} ProductName={brandSettings.ProductName}/>
                                                </div>
                                            )}
                                        </div>
                                        <button 
                                        onClick={() => {
                                            adobeAds.event('see_my_card_offers');
                                            Pixels.event("google", "PREQUAL", "Submit Application");
                                        }}
                                        disabled={isLoading || ((Setting.productSettings.CaptchaKey !== null) &&recaptchaDisabled)} id="submit-app" style={{backgroundColor : Setting.brandSettings.Tertiary}} className="btn text-small mt-3 btn-block" type="submit">
                                        {boldIf(isLoading ? 'Submitting...' :'See My Card Offers', brandSettings.ProductName === PRODUCT.Grand.bank)}
                                        </button>
                                        <div className="mt-4">
                                            <OfferExpirationNotice />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <div className="row">
                                        <div className="col-12">
                                            <Security />
                                        </div>
                                        <div className="col-12">
                                            <Reputation />
                                        </div>
                                        <div className="col-12">
                                            <Trustbox />
                                        </div>
                                        <div className="col-12">
                                            <Features />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </FormProvider>
            </div>
        </div>
    </>
  );
}

export default Landing;
